import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

function YesNoRow({ label, value, onChange, testId }) {
  const { t } = useTranslation();
  const opts = [
    { id: "yes", label: t("wizard.yesno.yes") },
    { id: "partial", label: t("wizard.yesno.partial") },
    { id: "no", label: t("wizard.yesno.no") },
    { id: "unknown", label: t("wizard.yesno.unknown") },
  ];
  return (
    <div className="py-4 border-b border-slate-100 last:border-0">
      <div className="text-slate-800 font-medium">{label}</div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2">
        {opts.map((o) => (
          <button key={o.id} type="button" onClick={() => onChange(o.id)}
            data-testid={`${testId}-${o.id}`}
            className={`rounded-sm border px-3 py-2 text-sm transition-colors ${
              value === o.id ? "border-brand-fuchsia bg-fuchsia-50/40 text-brand-bordeaux font-semibold" : "border-slate-200 text-slate-700 hover:border-brand-fuchsia"
            }`}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function Step6Compliance({ ref_data, value, onChange }) {
  const { t } = useTranslation();
  const set = (patch) => onChange(patch);
  const toggleFramework = (f) => {
    const cur = new Set(value.frameworks || []);
    if (cur.has(f)) cur.delete(f); else cur.add(f);
    set({ frameworks: Array.from(cur) });
  };
  return (
    <div className="py-8 space-y-10" data-testid="step-6">
      <div>
        <div className="label-caps">{t("wizard.s6_frameworks")}</div>
        <div className="mt-3 flex flex-wrap gap-2">
          {ref_data.frameworks.map((f) => {
            const active = (value.frameworks || []).includes(f);
            return (
              <button key={f} type="button" onClick={() => toggleFramework(f)}
                data-testid={`comp-fw-${f}`}
                className={`rounded-sm border px-3 py-2 text-sm transition-colors ${
                  active ? "border-brand-fuchsia bg-fuchsia-50/40 text-brand-bordeaux font-semibold" : "border-slate-200 text-slate-700 hover:border-brand-fuchsia"
                }`}>
                {f}
              </button>
            );
          })}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          [t("wizard.s6_audits"), "audits_per_year"],
          [t("wizard.s6_hours"), "audit_hours"],
          [t("wizard.s6_people"), "people_involved"],
          [t("wizard.s6_adhoc"), "auditor_ad_hoc_hours"],
        ].map(([label, key]) => (
          <div key={key}>
            <div className="label-caps">{label}</div>
            <Input type="number" min={0} value={value[key]} onChange={(e) => set({ [key]: parseFloat(e.target.value || "0") })} className="mt-2" data-testid={`comp-${key}`} />
          </div>
        ))}
      </div>

      <div className="card-flat p-6">
        <YesNoRow label={t("wizard.s6_manual")} value={value.manual_evidence} onChange={(v) => set({ manual_evidence: v })} testId="comp-manual" />
        <YesNoRow label={t("wizard.s6_findings")} value={value.past_findings} onChange={(v) => set({ past_findings: v })} testId="comp-findings" />
        <YesNoRow label={t("wizard.s6_insurance")} value={value.insurance_requirements} onChange={(v) => set({ insurance_requirements: v })} testId="comp-insurance" />
        <YesNoRow label={t("wizard.s6_iam")} value={value.iam_pam_required} onChange={(v) => set({ iam_pam_required: v })} testId="comp-iam-pam" />
        <YesNoRow label={t("wizard.s6_reports")} value={value.reports_available} onChange={(v) => set({ reports_available: v })} testId="comp-reports" />
        <YesNoRow label={t("wizard.s6_continuous")} value={value.continuous_evidence} onChange={(v) => set({ continuous_evidence: v })} testId="comp-continuous" />
      </div>

      <p className="text-xs text-slate-500 leading-relaxed">
        {t("wizard.s6_note")}
      </p>
    </div>
  );
}

export const step6Valid = () => true;
